export const generateProxyLink = (lang, type, urlParam) => {
  switch (type) {
    case "ipv4": return `/${lang}/${urlParam}/`;
    case "mobile": return `/${lang}/mobile/?country=${urlParam}`;
    default: return `/${lang}/${type}/?country=${urlParam}`;
  }
};
